import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Herrer.jpg'
import _imports_1 from '@/assets/img/Damer.jpg'
import _imports_2 from '@/assets/img/Drenge.jpg'
import _imports_3 from '@/assets/img/Piger.jpg'
import _imports_4 from '@/assets/img/Paradart.jpg'


const _withScopeId = n => (_pushScopeId("data-v-a47f8530"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = { class: "rankingsmain" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "display-2 mb-4 centertext" }, "Ranglister", -1))
const _hoisted_5 = { class: "flexbox" }
const _hoisted_6 = { class: "flexitem" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ranghover" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "350"
  })
], -1))
const _hoisted_8 = { class: "flexitem" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ranghover" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "350"
  })
], -1))
const _hoisted_10 = { class: "flexitem" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ranghover" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    width: "350"
  })
], -1))
const _hoisted_12 = { class: "flexitem" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ranghover" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    width: "350"
  })
], -1))
const _hoisted_14 = { class: "flexitem" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ranghover" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    width: "350"
  })
], -1))
const _hoisted_16 = { class: "sidebar-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftSideBar = _resolveComponent("LeftSideBar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_front_sidebar = _resolveComponent("front-sidebar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LeftSideBar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, { to: {name: 'Rankinglist', params: { rankingSlug: 'herrer' }, } }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_router_link, { to: {name: 'Rankinglist', params: { rankingSlug: 'damer' }, } }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, { to: {name: 'Rankinglist', params: { rankingSlug: 'drenge' }, } }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_router_link, { to: {name: 'Rankinglist', params: { rankingSlug: 'piger' }, } }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_router_link, { to: {name: 'Rankinglist', params: { rankingSlug: 'paradart' }, } }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_front_sidebar)
    ])
  ]))
}